import { ArrayInput, SimpleFormIterator } from "react-admin";
import { SettingsPage, SettingsUpdate } from "./settingUpdate";
import { ArtistReferenceInput } from "./artists";

export const FeaturedArtists = () => {
    return (
        <SettingsPage title="Featured Artists">
            <SettingsUpdate url="/cms/featured_artist">
                <ArtistReferenceInput source="artist_id" label="Today's featured artist" />
            </SettingsUpdate>

            <SettingsUpdate url="/cms/featured_artists">
                <p>Possible artists to be selected as "Artist of the day"</p>
                <ArrayInput source="artist_ids" fullWidth label="Featured artists selection">
                    <SimpleFormIterator inline>
                        <ArtistReferenceInput />
                    </SimpleFormIterator>
                </ArrayInput>
            </SettingsUpdate>
        </SettingsPage>
    );
};
